import React from 'react'
import BookingWidget from '../BookingWidget'

const MobileApp = () => {
  const { dictionary, hertzLogo } = window.mobileAppData

  return (
    <div className="s-app-tabs s-app-tabs--mobile-app">
      <div className="s-app-tabs__tabs-container">
        <div className="s-app-tabs__tab s-app-tabs__tab--selected">
          <i className="icon-car-solid"></i>
          <span>{dictionary.bookTabLabel}</span>
        </div>
      </div>
      <div className="page-container s-app-tabs__content">
        <BookingWidget mobileApp />

        <div className="s-app-tabs__footer">
          <span>{dictionary.poweredBy}</span>
          <img src={hertzLogo} alt="Hertz" />
        </div>
      </div>
    </div>
  )
}

export default MobileApp
